export default "__VITE_ASSET__6e667f14__"